import moment from 'moment'

export default time => {
  const timeMoment = moment(time)
  return `${timeMoment.format('DD.MM.YYYY')} (${timeMoment.fromNow()})`
}
